import React, { useEffect } from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import Button, { TYPES } from '../../Button/index'
import { connect as connectStaticText } from '../../StaticText/connect'
import { getBoundActions } from '../../../actions/index'
import { PAYMENT_INFO_PAGE_GA4_EVENT } from '../../../services/event-tracking/index'
import CartSinglePagePaymentInfo, { MODE } from './CartSinglePagePaymentInfo'
import { handleRestartSubscription } from '../utils'

/**
 * Component to handle the one-click payment
 * @param {Map} props.staticText - Static text translations
 * @param {Map} props.checkout - Checkout state
 * @param {Function} props.setRenderProcessing - Function to set render processing
 * @param {Function} props.setCheckoutWinbackUseDefaultPayment
 * @returns {React.ReactNode}
 */
function CartSinglePagePaymentOneClick (props) {
  const {
    staticText,
    checkout,
    setEventDefault,
    setRenderProcessing,
    setCheckoutSinglePageStep,
    sendOptimizelyFeatureEvent,
    setCheckoutWinbackUseDefaultPayment,
  } = props
  const orderError = checkout.get('orderError')

  useEffect(() => {
    if (orderError) {
      setRenderProcessing(false)
      setCheckoutWinbackUseDefaultPayment(false)
    }
  }, [orderError])

  const onClickUseThisPaymentMethod = () => {
    setRenderProcessing(true)
    handleRestartSubscription(props)
  }

  const onClickViewOtherPaymentOptions = () => {
    // use default payment flag
    setCheckoutWinbackUseDefaultPayment(false)

    // GA4 + optimizely event for Payment screen
    setEventDefault(PAYMENT_INFO_PAGE_GA4_EVENT)
    sendOptimizelyFeatureEvent({ eventName: 'payment_info_page' })

    // Set Checkout step
    setCheckoutSinglePageStep(3, 5)
  }

  return (
    <div className="cart-single-page__payment-one-click">
      <CartSinglePagePaymentInfo
        {...props}
        mode={MODE.LIGHT}
      />
      <Button
        type={TYPES.PRIMARY}
        onClick={onClickUseThisPaymentMethod}
        className="cart-single-page__payment-one-click-button"
      >
        {staticText.getIn(['data', 'useThisPaymentMethod'])}
      </Button>
      <Button
        type={TYPES.SECONDARY}
        onClick={onClickViewOtherPaymentOptions}
        className="cart-single-page__payment-one-click-button"
      >
        {staticText.getIn(['data', 'viewOtherPaymentOptions'])}
      </Button>
    </div>
  )
}

export default compose(
  connectStaticText({ storeKey: 'CartSinglePage' }),
  connectRedux(
    (state) => ({
      auth: state.auth,
      user: state.user,
      userAccount: state.userAccount,
      velocityCheck: state.velocityCheck,
      inboundTracking: state.inboundTracking,
      userLanguage: state.userLanguage,
      velocityCheckToken: state.velocityCheck.getIn(['data', 'velocityCheck', 'token']),
      paytrack: state.paytrack,
      plans: state.plans,
      checkout: state.checkout,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        processCheckoutOrder: actions.checkout.processCheckoutOrder,
        setCheckoutWinbackUseDefaultPayment: actions.checkout.setCheckoutWinbackUseDefaultPayment,
        setEventDefault: actions.eventTracking.setEventDefault,
        setCheckoutSinglePageStep: actions.checkout.setCheckoutSinglePageStep,
        sendOptimizelyFeatureEvent: actions.optimizelyFeature.sendOptimizelyFeatureEvent,
      }
    },
  ),
)(CartSinglePagePaymentOneClick)
